import { WandStarsIcon, styled } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

const PREMIUM_FILL_COLOR = 'linear-gradient(270deg, #1751D0 0%, #CD55A6 100%)'

const SeeMoreRibbonContainer = styled('div', { name: 'SeeMoreRibbonContainer' })({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 24,
  width: 'fit-content',
  padding: '0 8px',
  borderRadius: 4,
  fontFamily: 'Inter',
  fontSize: 10,
  fontWeight: 500,
  textTransform: 'uppercase',
  background: `linear-gradient(#ffffff, #ffffff) padding-box, ${PREMIUM_FILL_COLOR} border-box`,
  border: '1px solid transparent',
  color: PREMIUM_FILL_COLOR,
  gap: 4,
})

const SeeMoreRibbonText = styled('span', { name: 'SeeMoreRibbonText' })({
  fontSize: 10,
  fontWeight: 600,
  backgroundImage: PREMIUM_FILL_COLOR,
  backgroundClip: 'text',
  color: 'transparent',
  display: 'inline-block',
})

export const SeeMoreRibbon = () => {
  const translate = useTranslate()

  return (
    <SeeMoreRibbonContainer>
      <WandStarsIcon size={18} color="#CD55A6" />
      <SeeMoreRibbonText>{translate('See more')}</SeeMoreRibbonText>
    </SeeMoreRibbonContainer>
  )
}

export default SeeMoreRibbon
